import { ChecklistSection, DashboardProgress } from '../../types/dashboard'
import { LaunchSectionsEnum } from '../content/checklistContent'

/**
 * Helper function to calculate progress from sections
 */
export const calculateProgress = (sections: ChecklistSection[]): DashboardProgress => {
  const progress: DashboardProgress = {
    required: { completed: 0, total: 0 },
    optional: { completed: 0, total: 0 },
  }

  sections
    .filter(section => section.key !== LaunchSectionsEnum.LAUNCH)
    .forEach(section => {
      const isRequired = section.key === LaunchSectionsEnum.REQUIRED_FOR_LAUNCH
      const sectionProgress = isRequired ? progress.required : progress.optional

      section.items.forEach(item => {
        sectionProgress.total++
        if (item.isCompleted) {
          sectionProgress.completed++
        }
      })
    })

  return progress
}

/**
 * Check if setup is complete based on progress
 */
export const isSetupComplete = (progress: DashboardProgress): boolean => {
  return progress.required.completed === progress.required.total && progress.required.total > 0
}
